<rask-map-popup-content [abort]="closePopup" [canEdit]="canEdit" [edit]="edit" [delete]="removeCurrentGraphic">
  <ng-container header>{{skogsvardHeader}}</ng-container>
  <rask-input label="Figurareal" [readonly]="true"
  value="{{figurAreal | number:'1.2-2'}} {{figurarealText}}"></rask-input>
  @if (canEdit) {
    <rask-button-stack class="col-12 align-left ms-0 ps-0 pe-0">
      <rask-action-button (click)="addArea()" icon="far fa-plus">Lägg till delyta</rask-action-button>
      <rask-action-button (click)="cut()" icon="far fa-crop-alt">Beskär</rask-action-button>
      <rask-action-button (click)="openCreateSkogsvardModal()"
      icon="far fa-hand-holding-seedling">Lägg till skogsvård på yta</rask-action-button>
    </rask-button-stack>
  }
</rask-map-popup-content>